module.exports = __webpack_public_path__ + "static/img/アセット 20@2x.2df5c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 20@2x.png
// module id = BBld
// module chunks = 1